module.exports = __webpack_public_path__ + "img/ktirio.0204fc69.png";